<template>
    <div v-loading="$parentInfo.studentCart.dialog_DiscountType.loading">
        <div>
            <el-form label-width="100px">
                <el-form-item label="优惠类型">
                    <el-select v-model="discounts" placeholder="请选择"
                               multiple @change="chooseDiscount()">
                        <el-option-group
                                v-for="item in orderDiscountTypes"
                                :key="item.id">
                            <el-option
                                    v-for="item1 in item.discountType_details"
                                    :key="item1.id"
                                    :label="item.name"
                                    :value="item1.id"
                                    :disabled="item1.status">
                                <span style="float: left">{{ item.name }} {{item1.remark}}</span>
                                <span style="margin-left: 20px; color: #8492a6; ">{{ item1.balance }}</span>
                            </el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>
                <!--<el-row :gutter="20">-->
                <!--<el-form-item label="双十二优惠">-->
                <!--<el-input v-model="$parentInfo.studentCart.dialog_DiscountType.otherDiscount" size="small"-->
                <!--type="number" style="width: 200px"></el-input>-->
                <!--</el-form-item>-->
                <!--</el-row>-->
                <el-form-item label="总优惠">
                    <el-input v-model="allDiscount" size="small" disabled type="number"
                              style="width: 100px"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="text-right">
            <el-button type="primary" size="small" @click="handleStoreCartDiscount()"
                       :loading="$parentInfo.studentCart.dialog_DiscountType.button_loading">确 定
            </el-button>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Dialog_DiscountType',
        data() {
            return {
                discounts: '',
                otherDiscount: 0,
            };
        },
        mounted() {
        },
        computed: {
            orderDiscountTypes: function () {
                return this._.orderBy(this.$parentInfo.studentCart.dialog_DiscountType.discountTypes, 'status', 'asc');
            },
            allDiscount: function () {
                let sumDiscount = 0;
                for (let i in this.discounts) {
                    if (this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.discounts[i]].type === 'balance') {
                        sumDiscount += parseFloat(this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.discounts[i]].balance)
                    }
                }
                if (this.otherDiscount != '') {
                    sumDiscount += parseFloat(this.otherDiscount);
                }
                return sumDiscount
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleDiscountType();
        },
        methods: {
            handleDiscountType() {
                this.$wApi.send(this.$parentInfo.path, 'get_discountTypes', {
                    'selections': this.$store.state.modal.data.selections,
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleStoreCartDiscount() {
                this.$wApi.send(this.$parentInfo.path, 'store_cart_discount', {
                    'discounts': this.discounts,
                    'otherDiscount': this.otherDiscount,
                    'student_id': this.$parentInfo.student_id,
                    'selections': this.$store.state.modal.data.selections,
                });
                // this.$axios.post(store.state.server + '/studentCart/discountType' + '?' + localStorage.baseUrl, {
            },
            chooseDiscount() {
                this.$parentInfo.studentCart.dialog_DiscountType.discountTypes = JSON.parse(JSON.stringify(this.$parentInfo.studentCart.dialog_DiscountType.standbyDiscountTypes));
                if (this.discounts.length > 0) {
                    for (let i in this.discounts) {
                        if (this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.discounts[i]].overlay === 1) {
                            let vm = this;
                            this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.discounts[i]].discountType_id].discountType_details.forEach((item, index) => {
                                if (item.id !== vm.discounts[i]) {
                                    item.status = true;
                                }
                            });
                        }
                        if (this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.discounts[i]].discountType_id].overlay === 1) {
                            let vm = this;
                            for (let j in this.$parentInfo.studentCart.dialog_DiscountType.discountTypes) {
                                if (this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].id !== this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[vm.$parentInfo.studentCart.dialog_DiscountType.discountType_details[vm.discounts[i]].discountType_id].id) {
                                    this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].discountType_details.forEach((item, index) => {
                                        item.status = true;
                                    });
                                }
                            }
                        } else {
                            let vm = this;
                            for (let j in this.$parentInfo.studentCart.dialog_DiscountType.discountTypes) {
                                if (this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].id !== this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[vm.$parentInfo.studentCart.dialog_DiscountType.discountType_details[vm.discounts[i]].discountType_id].id) {
                                    if (this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].overlay === 1) {
                                        this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].discountType_details.forEach((item, index) => {
                                            item.status = true;
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .card-body {
        height: calc(100vh - 125px);
    }

    .card-footer {
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }
</style>
